import axios from "axios";
import axiosInstance from "@/lib/axios";
import type {
  ApiSuccessResponse,
  ApiErrorResponse,
  WatchlistQueryParams,
  AddToWatchlistPayload,
  AddToWatchlistResponse,
} from "@/types/watchlist";

const WATCHLIST_URL = "/watchlist";

export const getWatchlist = async (
  params?: WatchlistQueryParams
): Promise<ApiSuccessResponse> => {
  try {
    const res = await axiosInstance.get<ApiSuccessResponse>(WATCHLIST_URL, {
      params,
    });
      console.log("res.data", res);
    return res.data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      const apiError = err.response?.data as ApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
};

export const addToWatchlist = async (
  payload: AddToWatchlistPayload
): Promise<AddToWatchlistResponse> => {
  try {
    const res = await axiosInstance.post<AddToWatchlistResponse>(
      WATCHLIST_URL,
      payload
    );

    return res.data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      throw err.response?.data as ApiErrorResponse;
    }
    throw err;
  }
};